import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import axios from 'axios';
Vue.use(VueRouter)

const isAuth = async (from, to, next) =>{
  // next()
  /* This is a guard that checks if the user is logged in. If they are, they can proceed to the next
  page. If they are not, they are redirected to the login page. */
  if(store.state.id_user && store.state.isLoggedIn)
  {
    next()
  }else{
    localStorage.clear();
    if(!store.state.id_user)
    {
      axios.post('/register').then(res=>{
         store.dispatch("setLoggedIn", true);
          store.dispatch("setIdUser", res.data.id);
          next('/dashboard')
      })
    }
  }
}

const routes = [
  {
    path: '/',
    name: 'splash',
    component: ()=>import('@/views/DashboardView'),
    beforeEnter:isAuth
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/NewsView')
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/PaymentView')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/ProfileView'),
    beforeEnter:isAuth
  },
  {
    path: '/pin',
    name: 'pin',
    component: () => import('@/views/PinView')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/DashboardView'),
    beforeEnter:isAuth
  },
  {
    path: '/crypto/:currency',
    name: 'crypto',
    component: () => import('@/views/CryptoView'),
    beforeEnter:isAuth
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
